import { LogisticsProjectionType, RouteLegTypeEnum } from '@/api/apis/route';
import { Case } from '@/api/apis/case';
import { MultiSuggestRoutePlanType } from '@/utils/route/chains';

export enum StatisticsItemTypeEnum {
  FlightHours = 'FlightHours',
  BlockHours = 'BlockHours',
  DriveHours = 'DriveHours',
  TmdxAviaUsed = 'TmdxAviaUsed',
  TmdxAviaLegs = 'TmdxAviaLegs',
  TmdxRepositionLegs = 'TmdxRepositionLegs',
  TmdxReturnToBaseLegs = 'TmdxReturnToBaseLegs',
  AccommodationLegs = 'AccommodationLegs',
  CommercialFlightLegs = 'CommercialFlightLegs',
  TedsLegs = 'TedsLegs',
  CasesWithRoutes = 'CasesWithRoutes',
  MissingResources = 'MissingResources',
}

type StatisticsItemDelta<T> = {
  value: T;
  isNegative: boolean;
};

type StatisticsItemChanges<T> = {
  oldValue: T;
  newValue?: T;
};

type StatisticsItemSplit<T> = {
  type: RouteLegTypeEnum;
  delta?: StatisticsItemDelta<T>;
} & StatisticsItemChanges<T>;

export type StatisticsItemType<T = string> = {
  type: StatisticsItemTypeEnum;
  changes: StatisticsItemChanges<T>;
  delta?: StatisticsItemDelta<T>;
  isWarning?: boolean;
  children?: StatisticsItemSplit<T>[];
};

export type QueryResultType<T> = {
  data: T;
  isLoading: boolean;
};

export type UseMultiSuggestStatisticsProps = {
  taskId: string;
  caseIds: string[];
  logisticsIds: string[];
  chainNumber: number;
};

export type CaseCoverageType = Pick<Case, 'caseId' | 'serviceType'> & {
  logistics: Pick<LogisticsProjectionType, 'routes' | 'resources'>;
  plan: Pick<
    MultiSuggestRoutePlanType,
    'resources' | 'legs' | 'hasRealCommercialFlight' | 'hasFakeCommercialFlights' | 'ocsWarning' | 'specialistWarning'
  >;
};
